import { render, staticRenderFns } from "./PartnerUrlTable.vue?vue&type=template&id=212d6ff5&"
import script from "./PartnerUrlTable.vue?vue&type=script&lang=js&"
export * from "./PartnerUrlTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports